import { Injectable } from '@angular/core';
import { Language } from '../models/language.model';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private apiUrl = `${environment.sgcApi}`;
  private languagesRoute = 'languages';

  constructor(
    private httpClient: HttpClient
  ) {}

  getLanguages() : Observable<Language[]> {
    return this.httpClient.get<Language[]>(`${this.apiUrl}${this.languagesRoute}`)
      .pipe(map((data) => data));
  }
}
